import { render } from "./AdminDetail.vue?vue&type=template&id=48e919f0"
import script from "./AdminDetail.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdminDetail.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script